import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Demo8 from "../pages/EditAccounts";
import { getLoggedInUser } from "../helpers";
import { Container, Col, Row, Alert } from "reactstrap";
import { AvForm, AvField, AvGroup } from "availity-reactstrap-validation";
import { connect } from "react-redux";
import { betSlipService } from "../redux/betslip/services";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import SmallLoader from "../components/SmallLoader/SmallLoader";

const Wallet = ({ setDepositModalOpen, setIframeMode }) => {
  const [user, setUser] = useState(getLoggedInUser());
  const [isLoading, setIsLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [amount, setAmount] = useState("");
  const navigate = useNavigate();
  const [showOtherInput, setShowOtherInput] = useState(false);
  const [iframeUrl, setIframeUrl] = useState(null);
  const { t } = useTranslation();
  const [paymentMethod, setPaymentMethod] = useState("");
  const [currency, setCurrency] = useState("");

  const cryptoOptions = [
    { code: "USDC.ERC20", name: "USDC.ERC20" },
    { code: "USDC", name: "USDC" },
    { code: "BTC", name: "Bitcoin" },
    { code: "ETH", name: "Ethereum" },
    { code: "SOL", name: "Solana" },
    { code: "DOGE", name: "Dogecoin" },
    { code: "XRP", name: "Ripple" },
  ];

  useEffect(() => {
    loadRecordsTables();
  }, []);

  const loadRecordsTables = () => {
    setIsLoading(true);
    const reqData = { guid: user.guid };
    betSlipService
      .fatchUserDetails(reqData)
      .then((res) => {
        console.log("USER DATA IN WALLET RESPONSE:", res.data);
        const data = res;
        setUserList(data.data);
        setIsLoading(false);

        if (data?.status_id === 2 || data?.status_id === 4) {
          window.location.href = "/logout";
          return;
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
    console.log("USER DATA IN WALLET:", reqData);
  };

  const handleValidSubmit = (event, values) => {
    console.log("values:", values);
    console.log("userList:", userList);
    console.log("userList?.id:", userList?.id);
    setIsLoading(true);
    if (!amount) {
      swal(
        "Validation Error",
        "Please select an amount before submitting.",
        "warning",
      );

      return;
    }

    if (!paymentMethod) {
      swal("Validation Error", "Please select a payment method.", "warning");
      return;
    }

    const { guid, user_id, code } = values;
    const payload = {
      guid,
      user_id: userList.id,
      amount,
      code,
      payment_method: paymentMethod,
      currency: currency,
    };

    betSlipService
      .addAmountToWallet(payload)
      .then((response) => {
        setIsLoading(false);
        console.log("FULL RESPONSE:", response);
        if (response?.status == true) {
          const paymentUrl = response?.paymentUrl;

          if (paymentUrl) {
            setIframeMode(true); // <-- IMPORTANT
            setIframeUrl(paymentUrl);
          } else {
            swal("Payment URL not found", { icon: "warning" });
          }
        } else {
          swal(response?.message || "Something went wrong", {
            icon: "info",
          }).then(() => {
            setDepositModalOpen(false);
            navigate("/user-profile/profile");
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
        swal(error.message || "Something went wrong", { icon: "error" });
      });
  };

  // betSlipService
  //   .addAmountToWallet(payload)
  //   .then((response) => {
  //     setIsLoading(false);

  //     console.log("FULL RESPONSE:", response);

  //     if (response?.status == true) {

  //       const paymentUrl = response?.paymentUrl;

  //       if (paymentUrl) {
  //          setIframeUrl(paymentUrl);
  //         // window.open(paymentUrl, "_blank" ,"noopener,noreferrer");// open payment page
  //       } else {
  //         swal("Payment URL not found", { icon: "warning" });
  //       }

  //     } else {

  //       swal(response?.message || "Something went wrong", { icon: "info" })
  //         .then(() => {
  //           setDepositModalOpen(false);
  //           navigate("/user-profile/profile");
  //         });
  //     }
  //   })
  //   .catch((error) => {
  //     setIsLoading(false);
  //     swal(error.message || "Something went wrong", { icon: "error" });
  //   });

  return (
    <React.Fragment>
      {/* {error && (
        <Alert color="danger" isOpen={error ? true : false}>
          <div dangerouslySetInnerHTML={{ __html: error }}></div>
        </Alert>
      )} */}

      {iframeUrl ? (
        <div
          style={{
            width: "100%",
            height: "70vh", // jitna chahe utna height set karo
            background: "#000",
            marginTop: "20px",
            marginBottom: "20px",
            borderRadius: "6px",
            overflow: "hidden",
          }}
        >
          <iframe
            src={iframeUrl}
            title="Payment Iframe"
            referrerpolicy="no-referrer"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              margin: "0",
            }}
            allow="payment"
          ></iframe>
        </div>
      ) : (
        <div className="account-pages ">
          <section className="">
            <Container>
              <div className="">
                <Row className="justify-content-center">
                  <Col className="col-xl-12 add-amount-card">
                    <div className="">
                      <div className="card--body">
                        <AvForm onValidSubmit={handleValidSubmit}>
                          <Row className="gy-1">
                            <div className="col-md-12">
                              <h3
                                style={{ textAlign: "center" }}
                                className="text-white"
                              >
                                {t("userProfile.depositPop.addAmount")}
                              </h3>
                            </div>

                            <div className="col-md-12">
                              <h5
                                style={{ textAlign: "center" }}
                                className="text-white"
                              >
                                {t("userProfile.depositPop.totalCashBalance")}:{" "}
                                {/* {userList?.total_cash_balance ? "€" : "0.00"}
                                {userList?.total_cash_balance} */}
                                  {`€ ${Number(userList.total_cash_balance).toFixed(2)}`}
                              </h5>
                            </div>
                            <div className="col-md-12">
                              <h5
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                }}
                              >
                                {t("userProfile.depositPop.conversionNote")}
                              </h5>
                            </div>

                            <AvField
                              type="hidden"
                              name="guid"
                              id="guid"
                              className="mb-0"
                              value={userList ? userList.guid : ""}
                            />

                            <div className="col-md-12">
                              <div className="form-group">
                                <select
                                  name="payment_method"
                                  value={paymentMethod}
                                  onChange={(e) =>
                                    setPaymentMethod(e.target.value)
                                  }
                                  className="form--control5 form-control style--two"
                                  required
                                >
                                  <option
                                    className=""
                                    style={{
                                      textAlign: "center",
                                      textAlignLast: "center",
                                    }}
                                    value=""
                                  >
                                    ---Select Payment Method---
                                  </option>

                                  <option
                                    className="payment-option"
                                    value="coinpayment"
                                  >
                                    Crypto{" "}
                                  </option>
                                  <option
                                    className="payment-option"
                                    value="card"
                                  >
                                    Credit Card
                                  </option>
                                </select>

                                {paymentMethod === "coinpayment" && (
                                  <div style={{ marginTop: "10px" }}>
                                    <label className="form-label text-white">
                                      Select Currency
                                    </label>
                                    <select
                                      className="form--control form-control style--two"
                                      value={currency}
                                      onChange={(e) =>
                                        setCurrency(e.target.value)
                                      }
                                    >
                                      <option value="">Select Currency</option>
                                      {cryptoOptions.map((c) => (
                                        <option key={c.code} value={c.code}>
                                          {c.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-12">
                              <div className="form-group">
                                <label
                                  htmlFor="amount"
                                  className="form-label text-white"
                                >
                                  {t("userProfile.depositPop.amount")}{" "}
                                  <span className="required text-danger">
                                    *
                                  </span>
                                </label>{" "}
                                <br />
                                {showOtherInput && (
                                  <AvField
                                    id="amount"
                                    type="text"
                                    className="form--control2 form-control style--two"
                                    name="amount"
                                    placeholder={t(
                                      "userProfile.depositPop.enterCustomAmount",
                                    )}
                                    onChange={(e) => setAmount(e.target.value)}
                                    value={amount}
                                  />
                                )}
                                {showOtherInput == false && (
                                  <AvGroup>
                                    <div className="activeAmount-wrap">
                                      {["20", "25", "50", "100"].map(
                                        (value) => (
                                          <label
                                            key={value}
                                            className={`cstm_btn2 amountH ${
                                              amount === value
                                                ? "activeAmount"
                                                : ""
                                            }`}
                                          >
                                            <input
                                              type="radio"
                                              name="amountRadio"
                                              value={value}
                                              checked={amount === value}
                                              onChange={() => setAmount(value)}
                                              className="d-none"
                                            />
                                            €{value}
                                          </label>
                                        ),
                                      )}
                                      <label
                                        className="cstm_btn2 amountH w-100"
                                        onClick={() => {
                                          setShowOtherInput(true);
                                          setAmount(""); // reset amount
                                          // setDepositModalOpen(false)
                                        }}
                                      >
                                        {t("userProfile.depositPop.other")}
                                      </label>
                                    </div>
                                  </AvGroup>
                                )}
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label
                                  htmlFor="code"
                                  className="form-label text-white"
                                >
                                  {t("userProfile.depositPop.bonusCode")}{" "}
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      marginLeft: "8px",
                                      color: "#aeaeae",
                                    }}
                                  >
                                    {t("userProfile.depositPop.minDepositNote")}
                                  </span>
                                </label>
                                <AvField
                                  id="code"
                                  type="text"
                                  className="form--control5 form-control style--two "
                                  name="code"
                                  placeholder={t(
                                    "userProfile.depositPop.enterBonusCode",
                                  )}
                                />
                              </div>
                            </div>
                            <div className="col center">
                              <button
                                className="cstm_btn2  active mb-3"
                                disabled={isLoading}
                              >
                                {t("userProfile.depositPop.submit")}
                              </button>
                            </div>
                            {isLoading && <SmallLoader />}
                          </Row>
                        </AvForm>
                      </div>
                    </div>
                  </Col>
                  {/* <Col className="col-xl-3">
                                    </Col> */}
                </Row>
              </div>
            </Container>
          </section>
        </div>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.Auth;
  return user;
};
export default connect(mapStateToProps)(Wallet);
